import { useEffect, useState } from "react";
import { parsePriceInput } from "@/components/services/service-meta";
import { paraCampo, reais } from "./use-plano";

/** Subtotal, desconto (editável antes da aprovação) e total. */
export function TotaisDoPlano({
  subtotal,
  desconto,
  total,
  semPreco,
  editavel,
  onDesconto,
}: {
  subtotal: number;
  desconto: number;
  total: number;
  semPreco: number;
  editavel: boolean;
  onDesconto: (cents: number) => void;
}) {
  const [campo, setCampo] = useState(paraCampo(desconto));
  useEffect(() => setCampo(paraCampo(desconto)), [desconto]);
  return (
    <div className="ml-auto w-full max-w-xs space-y-1.5 text-sm">
      <p className="flex justify-between text-zinc-600 dark:text-muted-foreground">
        Subtotal <span className="tabular-nums">{reais(subtotal)}</span>
      </p>
      <label className="flex items-center justify-between gap-3 text-zinc-600 dark:text-muted-foreground">
        Desconto (R$)
        {editavel ? (
          <input
            aria-label="Desconto"
            inputMode="decimal"
            value={campo}
            placeholder="0,00"
            onChange={(e) => setCampo(e.target.value)}
            onBlur={() => {
              const cents = campo.trim() ? parsePriceInput(campo) : 0;
              if (cents !== desconto) onDesconto(cents);
            }}
            className="h-8 w-28 rounded-md border border-zinc-200 bg-white px-2 text-right text-sm tabular-nums dark:border-border dark:bg-card"
          />
        ) : (
          <span className="tabular-nums">{desconto ? `− ${reais(desconto)}` : "—"}</span>
        )}
      </label>
      <p className="flex justify-between border-t border-zinc-200 pt-1.5 text-base font-semibold text-zinc-900 dark:border-border dark:text-foreground">
        Total <span className="tabular-nums">{reais(total)}</span>
      </p>
      {semPreco > 0 && (
        <p className="text-[11.5px] text-amber-600">
          {semPreco} procedimento{semPreco > 1 ? "s" : ""} sem preço — fora do total.
        </p>
      )}
    </div>
  );
}
